import type { IconSvgObject } from './types';

const Wav01Icon: IconSvgObject = [
  ["path", { d: "M4 12.9978L4.01994 3.99557C4.02238 2.89186 4.91845 1.99877 6.02216 2L12.9958 2.00776L20 8.99481L19.9922 12.9978M13 2.49778V6.99778C13 8.10235 13.8954 8.99778 15 8.99778H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 16V22L6.5 19L9 22V16M11.25 22L13 16H13.5L15.25 22M12.25 20H14.25M16 16L17.75 22H18.25L20 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Wav01Icon;
